/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DirectDepositBlockHistory_user = {
    readonly id: string;
    readonly narrativeDirectDepositBlockHistory: ReadonlyArray<{
        readonly whatHappened: string;
        readonly whenHappened: string;
        readonly doneBy: string;
        readonly reason: string;
    } | null>;
    readonly " $refType": "DirectDepositBlockHistory_user";
};
export type DirectDepositBlockHistory_user$data = DirectDepositBlockHistory_user;
export type DirectDepositBlockHistory_user$key = {
    readonly " $data"?: DirectDepositBlockHistory_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DirectDepositBlockHistory_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectDepositBlockHistory_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BlockHistoryEntry",
      "kind": "LinkedField",
      "name": "narrativeDirectDepositBlockHistory",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "whatHappened",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "whenHappened",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "doneBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '3102921f58b2d38d78b72cabe28293eb';
export default node;
